import { useState } from 'react'
import { message as $message } from 'antd'
// import { useSelector } from 'umi'

import { queryDistributorAfterSales } from '@/services/afterSale'

interface useGetDistributeAftersaleCountReturn {
    count: Number
    initCount: Function
}

export default (): useGetDistributeAftersaleCountReturn => {
    const [count, setCount] = useState(0)

    const initCount = async params => {
        if (window.MASTER_IS_CHANNEL) {
            return
        }
        try {
            const { success, message, total } = await queryDistributorAfterSales(params)
            if (success) {
                setCount(total || 0)
            } else {
                $message.error(message)
            }
        } catch (error) {
            console.error('catchError', error)
        }
    }

    return {
        count,
        initCount,
    }
}
